import { UUID } from "angular2-uuid";

export interface IBaseObjectArgs {
    id?: string;
    created?: any;
    createdBy?: string;
    serverCreated?: string;
    modified?: string;
    modifiedBy?: string;
    serverModified?: string;
}

const defaults = () => ({
    id: UUID.UUID(),
    created: "",
    createdBy: "",
    serverCreated: "",
    modified: "",
    modifiedBy: "",
    serverModified: ""
} as BaseObject);

export class BaseObject {
    id: string;
    created: any;
    createdBy: string;
    serverCreated: string;
    modified: string;
    modifiedBy: string;
    serverModified: string;

    constructor(data?: IBaseObjectArgs) {

        data = {...defaults(), ...data};

        Object.keys(data).forEach(key => {
            this[key] = data[key];
        });

    }
}



// WEBPACK FOOTER //
// ./src/core/business-objects/base-object/base-object.model.ts